import { render, staticRenderFns } from "./contractualProduct.vue?vue&type=template&id=706ae939&scoped=true"
import script from "./contractualProduct.vue?vue&type=script&lang=js"
export * from "./contractualProduct.vue?vue&type=script&lang=js"
import style0 from "./contractualProduct.vue?vue&type=style&index=0&id=706ae939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ae939",
  null
  
)

export default component.exports